import React, { useContext } from 'react';
import { Form } from 'vindi-ds-components';
import useToggle from '@hooks/feature_toggles';
import capitalizeWords from '@utils/capitalizeWords';
import api from '@services/api';
import { useNavigate } from 'react-router-dom';
import {
  CreateProductProvider,
  ProductContext,
} from '@pages/product/contexts/product_context';
import ValidationSchema from './validations';
import FormStructure from '../components/form_structure';
import DiscardModal from '../components/discard_modal';

function NewProduct() {
  const toggle = useToggle('new_product_page');

  if (toggle) {
    return (
      <CreateProductProvider>
        <DiscardModal
          subtitle='Todos os dados do produto serão perdidos. '
          confirm='Continuar criação'
          cancel='Descartar criação'
          title='Descartar criação de produto?'
        />
        <ProductForm />
      </CreateProductProvider>
    );
  }
  return null;
}

const handleSubmit = (values, navigate, setPriceRangeErrors) => {
  /* eslint-disable camelcase */
  const { schema_type, ...productParams } = values;

  if (['flat', 'per_unit'].includes(schema_type)) {
    delete productParams.pricing_schema_attributes.pricing_ranges_attributes;
  }

  productParams.invoice = productParams.invoice ? 'always' : 'never';

  const params = { product: productParams };
  api.post('/admin/products/', params).then((response) => {
    navigate(response.data);
    window.location.reload();
  }).catch(({ response }) => {
    if (response && response.data) {
      const priceRangeErros = [];

      // eslint-disable-next-line no-unused-vars
      Object.entries(response.data).forEach(([field, value]) => {
        priceRangeErros.push(`${value.join(', ')}`);
      });
      setPriceRangeErrors(capitalizeWords(priceRangeErros));
    }
  });
};

const ProductForm = () => {
  const { params, setPriceRangeErrors } = useContext(ProductContext);
  const navigate = useNavigate();

  return (
    <Form
      initialValues={params}
      onSubmit={(values) => handleSubmit(values, navigate, setPriceRangeErrors)}
      validationSchema={ValidationSchema()}
    >
      <FormStructure headerTitle='Novo Produto' footerTitle='Criar produto' footerSubtitle='Descartar' />
    </Form>
  );
};

export default NewProduct;
